import { saveAs } from 'file-saver'

import { useTranslation } from '@/core'
import { getPlatform } from '@/core/native/app'
import { useDeviceInfo } from '@/core/native/device'
import {
  createAlbum,
  downloadImageUrl,
  writeFile,
} from '@/core/native/filesystem'

/**
 * @description hook for download file
 * @returns {downloadCsv} use for download csv file
 */
export const useDownloadFile = () => {
  const { t } = useTranslation()
  const { deviceInfo } = useDeviceInfo()
  /**
   * @param {string} url
   */
  const downloadCsv = async (url: string) => {
    const isWindows = deviceInfo?.operatingSystem.includes('windows')
    const filename = getFilename(url, `${Date.now()}.csv`)
    if (getPlatform() === 'web') {
      if (isWindows) {
        const result = await fetch(url)
        const data = await result.blob()

        // NOTE: ファイルの先頭にBOMを付与
        const bom = new Uint8Array([0xef, 0xbb, 0xbf])
        const blob = new Blob([bom, data], { type: 'text/csv' })
        return saveAs(blob, filename)
      } else {
        return saveAs(url, filename)
      }
    }
    //download content file
    const result = await fetch(url)
    const data = await result.text()
    //save file to device
    const writeFileResult = await writeFile({ data, path: filename }).catch(
      error => {
        //translate error message
        throw new Error(t(error.message))
      }
    )
    if (!writeFileResult?.uri) {
      throw Error(t('fileNotSaved'))
    }
  }

  return { downloadCsv }
}

/**
 * @description 画像ダウンロードフック
 * @returns {downloadImage} 画像ダウンロード関数
 */
export const useDownlodImage = () => {
  const { t } = useTranslation()

  const downloadImage = async (url: string) => {
    const fileName = getFilename(url, `${Date.now()}`)
    if (getPlatform() === 'web') {
      return saveAs(url, fileName)
    }

    const albumIdentifier = await createAlbum()
    await downloadImageUrl({
      path: url,
      fileName,
      albumIdentifier,
    }).catch(error => {
      throw new Error(t(error.message))
    })
  }

  return { downloadImage }
}

/**
 * get filename from url
 * @param {string} url
 * @param {string} defaultName
 */
function getFilename(url: string, defaultName: string): string {
  const { pathname } = new URL(url)
  return pathname.split('/').pop() ?? defaultName
}
